import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import backButton from "./Images/back.png";

const HexagonalTube = () => {
  const userEmail = sessionStorage.getItem("userEmail");
  const navigate = useNavigate();
  const [folderName, setFolderName] = useState("default");
  const [hexUrl, setHexUrl] = useState("");
  const [glbUrl, setGlbUrl] = useState("");
  const [inputs, setInputs] = useState({
    af: "",
    thickness: "",
    length: "",
    fillet: "",
    chamfer: "",
  });

  useEffect(() => {
    if (!userEmail) navigate("/signin");
  }, [userEmail, navigate]);

  useEffect(() => {
    if (!document.querySelector("script#model-viewer")) {
      const script = document.createElement("script");
      script.id = "model-viewer";
      script.type = "module";
      script.src =
        "https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js";
      document.head.appendChild(script);
    }
  }, []);

  useEffect(() => {
    const fetchFolderName = async () => {
      try {
        const response = await fetch("https://www.d-rosa.ai/appname");
        const data = await response.json();
        setFolderName(data.foldername || "default");
      } catch (error) {
        console.error("Error fetching folder name:", error);
      }
    };
    fetchFolderName();
  }, []);

  const handleChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://www.d-rosa.ai/hexagonaltubedesign", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          file_path: `/var/www/myflaskapp/flask_static/${userEmail}/${folderName}`,
          user_email: userEmail,
          folder_path: folderName,
          af: parseFloat(inputs.af),
          thickness: parseFloat(inputs.thickness),
          length: parseFloat(inputs.length),
          fillet: parseFloat(inputs.fillet),
          chamfer: parseFloat(inputs.chamfer),
        }),
      });

      if (response.ok) {
        const data = await response.json();
        setHexUrl(data.hexurl || "");
        alert("Hexagonal tube design is completed!");
      } else {
        console.error("Error submitting hexagonal tube data");
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
    }
  };

  const handleView = async () => {
    try {
      const response = await fetch("https://www.d-rosa.ai/HexagonalTubetoGlbb", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          file_path: `/var/www/myflaskapp/flask_static/${userEmail}/${folderName}`,
          user_email: userEmail,
          folder_path: folderName,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        setGlbUrl(data.glburl || "");
      } else {
        console.error("Error converting hexagonal tube to GLB");
      }
    } catch (error) {
      console.error("Error in handleView:", error);
    }
  };

  return (
    <div id="image-container">
      <center>
        <h2 className="center-heading">Hexagonal Tube Design</h2>
      </center>

      <p>Signed in as: {userEmail}</p>

      <form onSubmit={handleSubmit}>
        <input type="number" name="af" value={inputs.af} onChange={handleChange} placeholder="Across Flats (mm)" className="w-full p-2 border rounded" required />
        <br /><br />

        <input type="number" name="thickness" value={inputs.thickness} onChange={handleChange} placeholder="Wall Thickness (mm)" className="w-full p-2 border rounded" required />
        <br /><br />

        <input type="number" name="length" value={inputs.length} onChange={handleChange} placeholder="Length (mm)" className="w-full p-2 border rounded" required />
        <br /><br />

        <input type="number" name="fillet" value={inputs.fillet} onChange={handleChange} placeholder="Fillet Radius (optional)" className="w-full p-2 border rounded" />
        <br /><br />

        <input type="number" name="chamfer" value={inputs.chamfer} onChange={handleChange} placeholder="Chamfer (optional)" className="w-full p-2 border rounded" />
        <br /><br />

        <button type="submit">Submit</button>
      </form>

      <br />
      <p>Hexagonal Tube File Path: {hexUrl}</p>
      <br />

      {hexUrl && (
        <>
          <button onClick={handleView} style={{ padding: "10px 20px", fontSize: "16px" }}>View</button>
          <br /><br />
          <a href={hexUrl} target="_blank" rel="noopener noreferrer">
            <button style={{ padding: "10px 20px", fontSize: "16px" }}>Download STEP</button>
          </a>
        </>
      )}

      {glbUrl && (
        <div style={{ marginTop: "20px" }}>
          <h3>3D Hexagonal Tube Model</h3>
          <model-viewer src={glbUrl} alt="Hexagonal Tube" auto-rotate camera-controls ar shadow-intensity="1" style={{ width: "600px", height: "400px", backgroundColor: "green" }}></model-viewer>
        </div>
      )}

      <br />
      <button onClick={() => navigate("/previous-page")}>
        <img src={backButton} alt="Back" width="60" height="60" />
      </button>

      <footer className="footer-section">
        <div className="text-6">&copy; 2022 HYDAX Hydraulics Pvt. Ltd. All rights reserved.</div>
      </footer>
    </div>
  );
};

export default HexagonalTube;
